export default __webpack_public_path__ + "static/media/1.069ea7a7.png";